import React from 'react';
import { recognizeItems } from '../data/content';
import { icons } from '../utils/icons';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Recognize() {
  return <section className="relative w-full overflow-hidden bg-night px-5 py-20 sm:py-28" data-id="element-197" data-mp="2w5g8dd3euiih">
      <div className="bg-stripes absolute inset-0" aria-hidden="true" data-id="element-198" data-mp="2r86lo57eokyc" />
      <div className="relative mx-auto max-w-6xl" data-id="element-199" data-mp="2m8bwq776y5fx">
        <SectionHeading eyebrow="¿Te suena familiar?" tone="dark" title="¿Te sentís identificado con estas situaciones?" subtitle="Si respondiste que sí al menos una vez, este kit es para vos." data-id="element-200" data-mp="2m93f2gbs26o9" />

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-201" data-mp="2d8f2lq218edh">
          {recognizeItems.map((item, index) => {
          const Icon = icons[item.icon];
          return <Reveal key={item.title} delay={index * 0.04} className="h-full" data-id="element-202" data-mp="bgshg54tndox" data-mpi={index}>
                <li className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-7" data-id="element-203" data-mp="6h61vp1itlcy">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand text-white" data-id="element-204" data-mp="3jlc0r58g7z38">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-205" data-mp="3nmxfyx8ggpgl" />
                  </span>
                  <h3 className="mt-6 font-display text-xl leading-tight text-white" data-id="element-206" data-mp="39npg024gxdbc">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-white/65" data-id="element-207" data-mp="3em92c3mz4r48">
                    {item.text}
                  </p>
                </li>
              </Reveal>;
        })}
        </ul>

        <Reveal delay={0.12} data-id="element-208" data-mp="b4h4i8m5pcy4">
          <p className="mx-auto mt-16 max-w-3xl text-center font-display text-3xl leading-tight text-white sm:text-5xl" data-id="element-209" data-mp="3slrxlvuos7z4">
            Te merecés{' '}
            <span className="relative inline-block whitespace-nowrap text-volt" data-id="element-210" data-mp="1e606kyk91qp">
              mucho más
              <span className="absolute inset-x-0 -bottom-1 h-[0.08em] rounded-full bg-volt/40" aria-hidden="true" data-id="element-211" data-mp="p3gupkpbhzwe" />
            </span>{' '}
            que esto
          </p>
        </Reveal>
      </div>
    </section>;
}